<template>
  <div
    class="elevation-12"
    style="

    position: fixed;
    right: 0;
    z-index: 15;
    max-height: calc(100% - 65px);
    overflow-y: auto;
    overflow-x: hidden;
"
  >
    <v-expansion-panels v-model="panelExpanded">
      <v-expansion-panel :key="0" expand-icon="fa-arrow-alt-circle-down">
        <v-expansion-panel-header>
          <h2 style="margin-right: 15px">
            <span class="ml-2 hidden-xs-only">Powiązane ({{ countAssigned }})</span>
            <span class="ml-2 hidden-sm-and-up" v-if="panelExpanded != null">Powiązane zamówienia ({{ countAssigned }})</span>
          </h2>
        </v-expansion-panel-header>
        <v-expansion-panel-content style="width: 430px">
          <div>
            <fieldset class="custom-fieldset">
              <legend>To samo zamówienie</legend>
              <div class="pa-0 pb-3" style="overflow-y: auto; max-height: 450px">
                <div v-if="travelServiceOrderItems.length === 0">
                  {{ $t("global.noData") }}
                </div>
                <div v-for="travelServiceOrderItem of travelServiceOrderItems" :key="travelServiceOrderItem.id">
                  <v-row no-gutters class="mb-1">
                    <travel-service-order-item-chip
                      :travel-service-order-item="travelServiceOrderItem"
                      click-url="/admin/travel-service/item/readonly/"
                      :new-tab="true"
                    />
                    <!--                  <v-spacer />-->
                    <!--                  <div style="float: right">-->
                    <!--                    <v-btn @click="" class="mx-0" icon slot="activator">-->
                    <!--                      <v-icon>remove_red_eye</v-icon>-->
                    <!--                    </v-btn>-->
                    <!--                  </div>-->
                  </v-row>
                </div>
              </div>
            </fieldset>

            <fieldset v-if="relatedNotInTheSameOrder.length > 0" class="custom-fieldset">
              <legend>Powiązane z innego zamówienia</legend>
              <div class="pa-0 pb-3" style="overflow-y: auto; max-height: 450px">
                <div v-if="travelServiceOrderItems.length === 0">
                  {{ $t("global.noData") }}
                </div>
                <div v-for="travelServiceOrderItem of relatedNotInTheSameOrder" :key="travelServiceOrderItem.id">
                  <v-row no-gutters>
                    <travel-service-order-item-chip
                      :travel-service-order-item="travelServiceOrderItem"
                      click-url="/admin/travel-service/item/readonly/"
                      :new-tab="true"
                      class="my-1"
                    />
                    <!--                  <v-spacer />-->
                    <!--                  <div style="float: right">-->
                    <!--                    <v-btn @click="" class="mx-0" icon slot="activator">-->
                    <!--                      <v-icon>remove_red_eye</v-icon>-->
                    <!--                    </v-btn>-->
                    <!--                  </div>-->
                  </v-row>
                </div>
              </div>
            </fieldset>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import TravelServiceOrderItemChip from "../Chips/TravelServiceOrderItemChip";
export default {
  name: "AdminOfferExpandablePanel",
  components: { TravelServiceOrderItemChip },
  props: {
    // documentType: {
    //   required: true,
    //   type: Number
    // },
    // value: {
    //   required: true,
    //   type: Object
    // }
  },
  data: () => ({
    templateList: [],
    panelExpanded: [false],
    dialog: false,
    dialogValues: {
      id: null,
      name: "",
      public: 0
    },
    travelServiceOrderItems: [],
    relatedItems: []
  }),
  computed: {
    travelServiceOrderItemId() {
      return parseInt(this.$route.params.id);
    },
    relatedNotInTheSameOrder() {
      return this.relatedItems.filter(v => typeof this.travelServiceOrderItems.find(e => e.id === v.id) === "undefined");
    },
    countAssigned() {
      return this.travelServiceOrderItems.length + this.relatedNotInTheSameOrder.length;
    }
  },
  created() {
    this.downloadAssigned();
  },
  methods: {
    downloadAssigned() {
      this.axios.get("admin/travel-service-admin/get-assigned?itemId=" + this.travelServiceOrderItemId).then(resp => {
        this.relatedItems = resp.data.related_items;
        this.travelServiceOrderItems = resp.data.travel_service_order_items;
      });
    }
  }
};
</script>

<style scoped></style>
